import { useMutation } from '@tanstack/react-query';
import config from '../../../../../../../../../config';

export interface DecisionTreeReportQuery {
  id: string;
  llmQuestion: string;
  name: string;
  questions: {
    id: string;
    markdown: string;
    value?: string;
    comment?: string;
  }[];
  summary?: string | null;
  summaryFinishedAt?: number;
}

async function queryAssistant(treeRun: DecisionTreeReportQuery): Promise<globalThis.ReadableStreamDefaultReader<Uint8Array>> {
  const streamingFetch = await fetch(`https://${config.ContentGeneration.StreamingUrl}/decisionTreeRun/summarize`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      treeRun,
      temperature: 0.0,
    }),
    credentials: 'include',
  });

  const reader = streamingFetch.body?.getReader();
  if (!reader) {
    throw new Error('Failed to get reader');
  }
  return reader;
}

export default function useQueryAssistantMutation() {
  return useMutation<globalThis.ReadableStreamDefaultReader<Uint8Array>, Error, { treeRun: DecisionTreeReportQuery }>(
    ['queryAssistant'],
    (args: { treeRun: DecisionTreeReportQuery }) => queryAssistant(args.treeRun),
  );
}
